import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export interface TeamWithRole {
  id: string;
  name: string;
  description: string | null;
  icon: string;
  created_at: string;
  updated_at: string;
  role: string;
}

export const useTeams = () => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['teams'],
    enabled: !!user,
    queryFn: async (): Promise<TeamWithRole[]> => {
      const { data, error } = await supabase
        .from('team_members')
        .select('role, teams(id, name, description, icon, created_at, updated_at)')
        .eq('user_id', user!.id);

      if (error) throw error;

      return (data ?? []).map((row: any) => ({
        ...row.teams,
        role: row.role,
      }));
    },
  });
};
